import { useState } from "react";
import { FileText, Stethoscope, FlaskConical, FileBadge, Baby, ClipboardList } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { fmtDate } from "@/lib/format";
import VisitReportDialog from "./VisitReportDialog";

const ICON = { lab: FlaskConical, certificate: FileBadge, referral: FileBadge, delivery: Baby };

export default function ReportsTab({ patient, history, onOpenRecord }) {
  const { t, lang } = useApp();
  const [rep, setRep] = useState(null);
  const { encounters, records } = history;
  const byDx = encounters.reduce((m, e) => { const k = (e.diagnosis || "").trim(); if (k) (m[k] = m[k] || []).push(e); return m; }, {});
  const docs = records.filter((r) => ["lab", "certificate", "referral", "delivery"].includes(r.kind));
  const Row = ({ icon: Icon, title, sub, onClick, testid }) => (
    <button type="button" onClick={onClick} className="w-full text-start rounded border border-[#CCCCCC] bg-white px-3 py-2 flex items-center gap-3 hover:bg-[#E5F1FB]" data-testid={testid}>
      <Icon className="w-5 h-5 text-[#2B79C2] shrink-0" /><div className="min-w-0 flex-1"><div className="font-bold text-sm truncate">{title}</div><div className="text-xs text-[#666] truncate">{sub}</div></div><FileText className="w-4 h-4 text-[#999]" />
    </button>
  );
  return (
    <div className="space-y-4" data-testid="reports-tab">
      <div className="text-xs text-[#555]">{t("file_no")}: <b dir="ltr">{patient.file_no}</b> · {encounters.length} {t("visits")} · {docs.length} {t("documents")}</div>
      {encounters.length > 1 && <Row icon={ClipboardList} title={t("full_history_report")} sub={`${encounters.length} ${t("visits")}`} onClick={() => setRep({ title: t("full_history_report"), encounters })} testid="report-full-btn" />}
      <section>
        <h3 className="font-bold text-sm mb-1">{t("reports_by_visit")}</h3>
        <div className="space-y-1">{encounters.map((e) => <Row key={e.id} icon={Stethoscope} title={`${t("visit_report")} · ${fmtDate(e.date, lang)}`} sub={`${e.doctor_name}${e.diagnosis ? ` · ${e.diagnosis}` : ""}`} onClick={() => setRep({ title: t("visit_report"), encounters: [e] })} testid="report-visit-btn" />)}
          {!encounters.length && <p className="text-sm text-muted-foreground">{t("hr_no_events")}</p>}</div>
      </section>
      <section>
        <h3 className="font-bold text-sm mb-1">{t("reports_by_diagnosis")}</h3>
        <div className="space-y-1">{Object.entries(byDx).map(([dx, list]) => <Row key={dx} icon={ClipboardList} title={dx} sub={`${list.length} ${t("visits")} · ${fmtDate(list[list.length - 1].date, lang)} → ${fmtDate(list[0].date, lang)}`} onClick={() => setRep({ title: `${t("diagnosis_report")} · ${dx}`, encounters: list })} testid="report-dx-btn" />)}
          {!Object.keys(byDx).length && <p className="text-sm text-muted-foreground">—</p>}</div>
      </section>
      <section>
        <h3 className="font-bold text-sm mb-1">{t("documents")}</h3>
        <div className="space-y-1">{docs.map((r) => <Row key={r.id} icon={ICON[r.kind] || FileText} title={r.name} sub={`${fmtDate(r.date, lang)} · ${r.result || ""}`} onClick={() => onOpenRecord(r)} testid="report-doc-btn" />)}
          {!docs.length && <p className="text-sm text-muted-foreground">—</p>}</div>
      </section>
      {rep && <VisitReportDialog patient={patient} encounters={rep.encounters} title={rep.title} onClose={() => setRep(null)} />}
    </div>
  );
}
